import axios from "axios";

// The backend refuses every call of a company user or candidate who still has contracts to
// accept (403 with data.contractsPending). This turns that refusal into a window event the
// contract gate listens for, so the blocking screen comes back even if the person never
// leaves the page (e.g. a candidate in the middle of a test).
export const CONTRACTS_PENDING_EVENT = "cuspro:contracts-pending";

const signalIfContractsPending = (status, body) => {
  if (status === 403 && body?.data?.contractsPending) {
    window.dispatchEvent(new Event(CONTRACTS_PENDING_EVENT));
  }
};

/** For the XMLHttpRequest upload helpers, which axios interceptors don't see. */
export const signalFromXhr = (xhr) => {
  let body = null;
  try {
    body = JSON.parse(xhr.responseText);
  } catch {
    // Not our JSON envelope, so not a contract refusal.
  }
  signalIfContractsPending(xhr.status, body);
};

let installed = false;

/**
 * Both axios-based clients (Helpers/ApiHelper and Services/HttpsClient) use the default axios
 * instance, so one response interceptor covers every axios call in the app.
 */
export const installContractsPendingSignal = () => {
  if (installed) return;
  installed = true;
  axios.interceptors.response.use(undefined, (err) => {
    signalIfContractsPending(err.response?.status, err.response?.data);
    return Promise.reject(err);
  });
};
